import React from "react";
import './style.css';
import logoEu from './file/logoEU.jpg';

function Footer() {
    return (

        <footer className="footer">
            <div className='container'>
                <div className='row'>
                    <div className="col-lg-4 mb-5 mb-lg-0">
                        <h4 className="text-uppercase mb-4"><label className="lang" key="usefulinks"> Useful Links</label> </h4>
                        <p>
                            <a href="https://www.cs.ucy.ac.cy/" target="=_blank" className="whiteLink"><label className="lang"
                                key="cs"> Computer Science Department</label></a><br></br>
                            <a href="http://www.pi.ac.cy/pi/index.php?lang=el" target="=_blank" className="whiteLink"><label
                                className="lang" key="cpi"> Cyprus Pedagogical Institute </label></a><br></br>
                            <a href="https://www.cybersafety.cy/" target="=_blank" className="whiteLink"> CyberSafety </a>
                        </p>
                    </div>
                    <div className="col-lg-4 mb-5 mb-lg-0">
                    </div>
                    <div className="col-lg-4">
                        <h4 className="text-uppercase mb-4"><label className="lang" key="fundingTitle"> Project Funding</label></h4>
                        <img src={logoEu} alt="" className="euroPic" />
                        <p className="footerText mb-0">
                            <label className="lang" key="fundingText">
                                The CYberSafety project is co-financed by the European Union's Connecting Europe Facility.
                                The sole responsibility of this publication lies with the author.
                                The European Union is not responsible for any use that may be made of the information
                                contained therein.
                            </label>
                        </p>
                    </div>
                </div>
            </div>

        </footer>

    );
}

export default Footer;